import { Component, OnInit } from '@angular/core';
import { Transaction } from '../../models';
import { TokenServiceService } from '../../services/token-service.service';
import { PseService } from '../../services/pse.service';
import { PseReturnTransaction } from '../../models/pseReturnTransaction';
import { AuthorizationDesc } from '../../models/order';
import { AlertService } from '../../services/alert.service';
import { PaymentMethodsService } from '../../services/payment-methods.service';
import { PrintServicesService } from '../../services/print-services.service';
import { Router } from '@angular/router';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';
import { createMerchantReturnUrl } from 'src/app/shared/helps/helps';
import { FLAGS_NAME, GENERAL_CONSTANTS, ORDER_STATES, PCOL_TRANSACTION_KEYS } from 'src/app/core/constants/General-constants';
import { formatDate } from 'src/app/services/helps/datesHelper.helper';
import { PuntosColombiaService } from 'src/app/services/puntos-colombia.service';

const TIME_OUT_TO_RETRY = 30;

@Component({
    selector: 'app-alertpse',
    templateUrl: './alertpse.component.html',
    styleUrls: ['./alertpse.component.scss'],
})
export class AlertpseComponent implements OnInit {
    private token: string;

    order: AuthorizationDesc;
    transaction: Transaction;
    infoPayment: boolean;
    loading: boolean = true;
    startDelay: boolean = false;
    pseReturnTransaction: PseReturnTransaction;
    redirect: string;
    response: string;
    icon: string;
    messageResponse: string;
    approve: boolean;
    pend: boolean;
    fail: boolean;
    timeIntervalToRequestAgain = TIME_OUT_TO_RETRY;
    tryLeftConsultTicket = 3;
    pColTransaction: any = {};
    userInfo: any = {};
    fixErrorAlertPseFF: boolean = false;
    enablePcoPointsAcummFF: boolean = false;
    acummulationByMerchantPcoFF: boolean = false;

    static loadStyle() {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = `./assets/css/root/default.css`;
        document.getElementsByTagName('HEAD')[0].appendChild(link);
    }

    constructor(
        private readonly tokenServiceService: TokenServiceService,
        private readonly alertService: AlertService,
        private readonly paymentMethodsService: PaymentMethodsService,
        private readonly pseService: PseService,
        private readonly printServicesService: PrintServicesService,
        private readonly router: Router,
        private featureFlagService: PayvalidaFeatureFlagService,
        private readonly pcoService: PuntosColombiaService
    ) { }

    // TODO https://dev.azure.com/payvalida/payValida/_workitems/edit/25139
    async ngOnInit() {
        this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.FIX_ERROR_ALERT_PSE_FF, FLAGS_NAME.FIX_ERROR_ALERT_PSE_FF).subscribe((response: boolean) => {
            this.fixErrorAlertPseFF = response;
        });

        this.featureFlagService.getFeatureFlagValue(FLAGS_NAME.ENABLE_PCO_POINTS_ACUMM_FF, FLAGS_NAME.ENABLE_PCO_POINTS_ACUMM_FF).subscribe((response: boolean) => {
            this.enablePcoPointsAcummFF = response;
        });

        this.transaction = this.tokenServiceService.getAndDecodeToken();

        this.featureFlagService.getFeatureFlagValue(this.transaction.MERCHANT_ID, FLAGS_NAME.ACUMM_PCO_BY_MERCHANT).subscribe((response: boolean) => {
            this.acummulationByMerchantPcoFF = response;
        });

        this.token = this.tokenServiceService.getToken();
        this.infoPayment = false;
        this.pColTransaction = JSON.parse(localStorage.getItem(`${PCOL_TRANSACTION_KEYS.PCOCL_TRANSACION_OBJECT_KEY}-${this.transaction.ORDER_REFERENCE}`)) ?? null;
        this.userInfo = JSON.parse(localStorage.getItem(`${PCOL_TRANSACTION_KEYS.PCO_INFO_ACUMMULATE_POINTS}-${this.transaction.ORDER_REFERENCE}`)) ?? null;

        AlertpseComponent.loadStyle();

        await this.processPSE();
    }

    /**
    * @description Handles the outcome of a PSE transaction by updating UI elements and managing navigation evaluating transaction status
    * @param {Object} data - Contains transaction details including status and optional data for further processing.
    */
    processResponseTicket(data: any) {
        this.pseReturnTransaction = new PseReturnTransaction();
        this.pseReturnTransaction = data.body;
        this.infoPayment = true;

        switch (data.body.STATUS) {
            case ORDER_STATES.APPROVED:
                this.aproved();

                this.acummulationByMerchantPcoFF && this.pcoService.pcoCheckAndAcummPoints(this.userInfo, this.token);

                localStorage.removeItem(`${PCOL_TRANSACTION_KEYS.PCO_INFO_ACUMMULATE_POINTS}-${this.transaction.ORDER_REFERENCE}`);
                break;

            case ORDER_STATES.REJECTED:
                this.failed();

                localStorage.removeItem(`${PCOL_TRANSACTION_KEYS.PCO_INFO_ACUMMULATE_POINTS}-${this.transaction.ORDER_REFERENCE}`);
                break;

            case ORDER_STATES.FAILED:
                this.failed();

                localStorage.removeItem(`${PCOL_TRANSACTION_KEYS.PCO_INFO_ACUMMULATE_POINTS}-${this.transaction.ORDER_REFERENCE}`);
                break;

            case ORDER_STATES.PENDING:
                this.pended();

                localStorage.removeItem(`${PCOL_TRANSACTION_KEYS.PCO_INFO_ACUMMULATE_POINTS}-${this.transaction.ORDER_REFERENCE}`);
                break;

            default:
                localStorage.removeItem(`${PCOL_TRANSACTION_KEYS.PCO_INFO_ACUMMULATE_POINTS}-${this.transaction.ORDER_REFERENCE}`);

                this.alertService.showAlertProblem();
                break;
        }
    }

    intervalLogic() {
        const retryRequestInterval = setInterval(async () => {
            if (this.timeIntervalToRequestAgain <= 0) {
                this.timeIntervalToRequestAgain = TIME_OUT_TO_RETRY;
                clearInterval(retryRequestInterval);
                this.tryLeftConsultTicket--;
                await this.processPSE();
            } else {
                this.timeIntervalToRequestAgain = this.timeIntervalToRequestAgain - 1;
            }
        }, 1000);
    }

    async processPSE() {
        try {
            if (this.tryLeftConsultTicket > 0) {
                const data = await this.pseService.PostTikect({ token: this.token });
                this.loading = false;
                if (data.statusCode === 201) {
                    if (this.pColTransaction != null) return this.processPCOL(data);

                    this.startDelay = true;

                    return this.processResponseTicket(data);
                }

                return this.intervalLogic();
            }

            this.startDelay = true;
            this.loading = false;
        } catch (_) {
            this.startDelay = true;
            this.loading = false;
        }
        if (this.transaction.MERCHANT_URL_RETURN) {
            try {
                this.order = await this.paymentMethodsService.Order({ pseff: this.fixErrorAlertPseFF });
                this.redirect = createMerchantReturnUrl(this.order.OrderID, this.transaction.MERCHANT_URL_RETURN);
                const aNumber = Number(this.transaction.REDIRECT_TIMEOUT);
                if (!isNaN(aNumber) && aNumber > 0) {
                    setTimeout(() => {
                        window.location.href = this.redirect;
                    }, aNumber);
                }
            } catch (e) {
                this.alertService.showAlertProblem();
            }
        } else {
            this.redirect = '';
        }
    }

    /**
    * @description Handles the outcome of a Puntos Colombia transaction by updating UI elements and managing navigation evaluating transaction status
    * @param {Object} data - Contains transaction details including status and optional data for further processing.
    */
    processPCOL(data: any) {
        this.loading = false;
        this.infoPayment = true;
        const date = new Date();
        this.pColTransaction.date = formatDate(date);

        switch (data.body.STATUS) {
            case ORDER_STATES.REJECTED:
            case ORDER_STATES.FAILED:
                localStorage.removeItem(`${PCOL_TRANSACTION_KEYS.PCO_INFO_ACUMMULATE_POINTS}-${this.transaction.ORDER_REFERENCE}`);

                return this.failed();

            case ORDER_STATES.PENDING:
                return this.pended();

            case ORDER_STATES.APPROVED:
                if (this.pColTransaction.status != GENERAL_CONSTANTS.OK_RESPONSE_CODE) {
                    localStorage.removeItem(`${PCOL_TRANSACTION_KEYS.PCO_INFO_ACUMMULATE_POINTS}-${this.transaction.ORDER_REFERENCE}`);

                    return this.failed();
                }

                this.aproved();

                this.enablePcoPointsAcummFF && this.pcoService.pcoCheckAndAcummPoints(this.userInfo, this.token);

                localStorage.removeItem(`${PCOL_TRANSACTION_KEYS.PCO_INFO_ACUMMULATE_POINTS}-${this.transaction.ORDER_REFERENCE}`);
                localStorage.removeItem(`${PCOL_TRANSACTION_KEYS.PCOCL_TRANSACION_OBJECT_KEY}-${this.transaction.ORDER_REFERENCE}`);
                break;
            default:
                localStorage.removeItem(`${PCOL_TRANSACTION_KEYS.PCO_INFO_ACUMMULATE_POINTS}-${this.transaction.ORDER_REFERENCE}`);

                this.alertService.showAlertProblem();
                break;
        }

    }

    aproved() {
        this.response = 'exitoso';
        this.icon = 'check-circle';
        this.messageResponse = 'Enviamos una notificación de tu pago al comercio.\n' + 'Si tienes alguna duda, ponte en contacto con:';
        this.pend = false;
        this.approve = true;
    }

    pended() {
        this.response = 'pendiente';
        this.icon = 'spinner';
        this.messageResponse = 'Comunícate con el comercio para comprobar el estado de tu transacción';
        this.pend = true;
        this.intervalLogic();
    }

    failed() {
        this.response = 'incorrecto';
        this.icon = 'exclamation-triangle';
        this.messageResponse = 'Comunícate con el comercio para comprobar el estado de tu transacción';
        this.pend = false;
        this.fail = true;
    }

    print() {
        this.printServicesService.downloadImage(document.getElementById('ticketDiv'), 'recibo_de_pago_payvalida');
    }

    async retryPayment(): Promise<void> {
        await this.router.navigate(['/'], { queryParams: { token: this.token } });
    }
}
